import React from 'react';
import { FileCode2, Scale, CheckCircle2 } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="pt-24 bg-gray-950 min-h-screen text-left">
      <section className="py-16 bg-gradient-to-b from-gray-950 via-slate-900 to-gray-950 border-b border-gray-800">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <div className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-4">
            <Scale className="w-4 h-4 text-orange-400" />
            <span className="text-orange-400 text-sm font-semibold uppercase tracking-wider">
              Terms & Conditions
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
            Terms of Service
          </h1>
          <p className="text-gray-400 text-sm">
            Service Level Agreements & Engineering Contracts
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-950">
        <div className="container mx-auto px-6 max-w-4xl space-y-8 text-gray-300 text-sm leading-relaxed">
          <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2">
              <FileCode2 className="w-5 h-5 text-cyan-400" />
              1. Engagement & Deliverables
            </h2>
            <p>
              All software development, web engineering, mobile app development, and staff augmentation services are governed by written Master Services Agreements (MSA) and Statements of Work (SOW) executed between client and HOASP International.
            </p>
          </div>

          <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-orange-400" />
              2. Intellectual Property Ownership
            </h2>
            <p>
              Upon final payment of project milestones, all custom source code, design assets, database schemas, and intellectual property rights are fully assigned to the client.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
